export const FETCH_USERS = {
  START: 'START_FETCH_USERS',
  COMPLETE: 'COMPLETE_FETCH_USERS',
  FAIL: 'FAIL_FETCH_USERS',
  CLEANUP: 'CLEANUP_FETCH_USERS',
}

export const FETCH_USER_DETAILS = {
  START: 'START_FETCH_USER_DETAILS',
  COMPLETE: 'COMPLETE_FETCH_USER_DETAILS',
  FAIL: 'FAIL_FETCH_USER_DETAILS',
  CLEANUP: 'CLEANUP_FETCH_USER_DETAILS',
}

export const UPSERT_USER_DETAILS = {
  START: 'START_UPSERT_USER_DETAILS',
  COMPLETE: 'COMPLETE_UPSERT_USER_DETAILS',
  FAIL: 'FAIL_UPSERT_USER_DETAILS',
}
